const frontendURL = '/srv/skd-master/';
const backendURL = '/api/repos/check-schema/';
const name = 'Конструктор СКД';

const getVisibility = (user) => user.is_superuser;

const instance = {
  frontendURL,
  backendURL,
  name,
  getVisibility,
};

export default instance;
